export type NationalityOption = {
  value: string;
  label: string;
};

type NationalityResponse = {
  id: string;
  name: string;
};

class NationalitiesService {
  getAll = () => serviceHttpGetFactory<NationalityResponse[]>('/apps/nationalities');
}

export const nationalitiesService = new NationalitiesService();

export const getNationalitiesForLocale = async (locale: string): Promise<NationalityOption[]> => {
  const result = await nationalitiesService.getAll();

  if (result.isSuccess) {
    return result.data.map((nationality) => ({
      value: nationality.id,
      label: nationality.name
    }));
  }

  console.error('Failed to fetch nationalities from API, falling back to local data:', result.message);

  // Fallback to local data
  try {
    const translations = await import(`./nationalities/${locale}.json`);

    return translations.default.map((nationality: { id: number; name: string }) => ({
      value: nationality.id.toString(),
      label: nationality.name
    })).sort((a, b) => a.label.localeCompare(b.label));
  } catch (fallbackError) {
    console.error('Failed to load fallback nationality data:', fallbackError);
    return [];
  }
};
